import React from "react";
import Navbar from "../../components/nav/NavBar";
import { Outlet } from "react-router-dom";

function Index() {
  return (
    <div className="max-w-[2000px] mx-auto">
      <Navbar />
      <div className="pt-[81px]">
        <Outlet />
      </div>
    </div>
  );
}

export default Index;
